import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M13.417 23.333c-.973 0-1.799-.34-2.48-1.02-.68-.681-1.02-1.507-1.02-2.48h2.333c0 .33.112.608.335.832.224.223.501.335.832.335.33 0 .607-.112.83-.335.225-.224.336-.501.336-.832 0-.33-.111-.607-.335-.83a1.129 1.129 0 0 0-.831-.336H2.333v-2.334h11.084c.972 0 1.798.34 2.479 1.021.68.68 1.02 1.507 1.02 2.48 0 .972-.34 1.798-1.02 2.479-.68.68-1.507 1.02-2.48 1.02ZM2.333 11.667V9.333h15.75c.506 0 .924-.165 1.255-.495.33-.331.495-.75.495-1.255 0-.505-.165-.923-.495-1.254-.331-.33-.75-.496-1.255-.496-.505 0-.923.166-1.254.496-.33.33-.496.749-.496 1.254H14c0-1.147.394-2.114 1.181-2.902.788-.787 1.755-1.181 2.902-1.181 1.148 0 2.115.394 2.902 1.181.788.788 1.182 1.755 1.182 2.902 0 1.148-.394 2.115-1.182 2.902-.787.788-1.754 1.182-2.902 1.182H2.333ZM21.583 21v-2.333c.506 0 .924-.166 1.255-.496.33-.33.495-.749.495-1.254 0-.506-.165-.924-.495-1.255-.331-.33-.75-.495-1.255-.495H2.333v-2.334h19.25c1.148 0 2.115.394 2.902 1.182.788.787 1.182 1.754 1.182 2.902 0 1.147-.394 2.114-1.182 2.902-.787.787-1.754 1.181-2.902 1.181Z"
    }, null, -1)
  ])))
}
export default { render: render }